import { isNotNil } from '@flowio/is';
var isBrowser = typeof window !== 'undefined' && isNotNil(window.document) && isNotNil(window.document.createElement);
export default isBrowser;
//# sourceMappingURL=isBrowser.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/~/@flowio/browser-helpers/lib/esm/isBrowser.js
// module id = 328
// module chunks = 0 1